import { ReactNode, useMemo } from 'react'
import cn from 'classnames'

import Cupcake from 'src/icons/cupcake.webp'
import Candy from 'src/icons/candy.webp'
import { ContentSteps } from 'src/lib/useStepFlow'
import { useControlModal, ModalType } from '@rockstar/registration-component'
import { SignUp } from 'src/features/registration/SignUp'
import { TLang } from 'src/constants/langs'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'

import { texts } from './text-fourth-step'
import { CustomButton } from '../../button/CustomButton'

import { textBtn } from './mock'

import styles from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const FourthStep = ({ lang }: TProps) => {
    const { header, content } = useLocalizedText<true>(lang, texts)
    const { modalType, setModalType } = useControlModal()

    const MODALS = useMemo<{ [key in ModalType]: ReactNode | null }>(
        () => ({
            sign_up: <SignUp language={lang} />,
            clear: null,
        }),
        [lang],
    )

    const isMultiLineContent = lang === 'sl' || lang === 'de' || lang === 'ro'

    const defaultText = textBtn.find((item) => item.lang === 'en')?.text ?? ''

    const getBtnTextByLang = () =>
        textBtn.find((item) => item.lang === lang)?.text || defaultText

    return (
        <div className={styles.root}>
            <div className={styles.text_wrapper}>{header}</div>
            <div
                className={cn(styles.mirror_wrapper, styles.hello)}
                style={{ backgroundImage: `url(${Cupcake})` }}
            >
                <img src={Candy} alt="Candy" className={styles.candy} />
                <div
                    className={cn(styles.container, {
                        [styles[`container--multi_line`]]: isMultiLineContent,
                    })}
                >
                    {content}
                </div>
                <div
                    className={styles.wrapper_button}
                    onClick={() => setModalType('sign_up')}
                >
                    <CustomButton
                        textBtn={getBtnTextByLang()}
                        classNames={{
                            textBtn: cn(styles.text_btn, {
                                [styles[`text_btn--${lang}`]]: lang === 'el',
                            }),
                        }}
                    />
                </div>
            </div>
            {MODALS[modalType]}
        </div>
    )
}
